import React from 'react';
import Content from '../components/Content';
import GenericSnack from '../components/GenericSnack';
import MainAuthorsContent from '../components/main/authors/create/MainAuthorsContent';
import MainAuthorFormStore from '../stores/MainAuthorFormStore';
import { useNavigate } from 'react-router';

const MainAuthorsCreate = ({userStore, snackStore}) => {
  const navigate = useNavigate();
  const mainAuthorFormStore = new MainAuthorFormStore(userStore, snackStore, navigate, true);
  return (
    <Content title='Criar Novo Autor-pai' userStore={userStore}>
      <GenericSnack snackStore={snackStore} />
      <MainAuthorsContent mainAuthorsFormStore={mainAuthorFormStore} />
    </Content>
  );
}

export default MainAuthorsCreate;
